// API Keys management endpoints

import { apiClient } from './client';
import type { CreateApiKeyRequest, ApiKeyCreatedResponse } from '../types/api';

/**
 * API Key management functions
 * Requires Management permission
 */
export const apiKeysApi = {
  /**
   * Create a new API key for an account
   *
   * Requires Management permission on the account
   *
   * @param accountId - Account UUID
   * @param request - API key creation request (name, optional expiration)
   * @returns Created API key (includes plain-text key_value - only shown once)
   */
  createKey: (accountId: string, request: CreateApiKeyRequest): Promise<ApiKeyCreatedResponse> => {
    return apiClient.post<ApiKeyCreatedResponse>(`/accounts/${accountId}/api-keys`, request);
  },

  // TODO: Add list and revoke methods when backend implements them
  // listKeys: (accountId: string): Promise<ApiKeyListResponse> => {
  //   return apiClient.get<ApiKeyListResponse>(`/accounts/${accountId}/api-keys`);
  // },
  //
  // revokeKey: (accountId: string, keyId: string): Promise<void> => {
  //   return apiClient.delete(`/accounts/${accountId}/api-keys/${keyId}`);
  // },
};
